import { memo } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Marker } from "react-mapbox-gl";
import { visiblePostcodeLabelsSelector } from "../../reducers/depot/selectors";

const useStyles = makeStyles({
  marker: {
    fontSize: "12px",
    pointerEvents: "none",
  },
});

export const DepotPostcodeLabelsLayer = memo(() => {
  const styles = useStyles();
  const postcodeLabels = useSelector(visiblePostcodeLabelsSelector);

  return (
    <>
      {postcodeLabels.map(({ postcode, coordinates }) => {
        return (
          <Marker
            className={styles.marker}
            key={postcode}
            coordinates={coordinates}
            anchor={"center"}
          >
            {postcode}
          </Marker>
        );
      })}
    </>
  );
});
